export class GalleryUnitElement {

  private token:string;
  private imgUrl:string;

  constructor(json:any) {
    if(json!=null) {
      this.token = json.token;
      this.imgUrl = json.imgUrl;
    }

  }

  public setToken(token:string) {
    this.token = token;
  }

  public setImgUrl(url:string) {
    this.imgUrl = url;
  }

  public getToken():string {
    return this.token;
  }

  public getImgUrl():string {
    return this.imgUrl;
  }

}
